import {
  USER_POOL_WEB_CLIENT_ID,
  USER_POOL_ID,
  REGION,
} from "../constants/Config"
import { Amplify } from "aws-amplify"
import {
  signIn,
  signOut,
  fetchAuthSession,
  AuthUser,
  getCurrentUser,
  fetchUserAttributes,
  resetPassword,
  confirmResetPassword,
  signUp as amplifySignUp,
  confirmSignUp as amplifyConfirmSignUp,
  resendSignUpCode,
} from "aws-amplify/auth"
import { messaging } from "../lib/firebase"
import { deleteToken } from "firebase/messaging"

const userPoolWebClientId = USER_POOL_WEB_CLIENT_ID

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: USER_POOL_ID,
      userPoolClientId: USER_POOL_WEB_CLIENT_ID,
    },
  },
})

export function login(
  username: string,
  password: string,
  clearStorage: boolean = true
) {
  try {
    if (clearStorage) {
      localStorage.clear()
    }
    return signIn({ username, password })
  } catch (error) {
    window.console.log("error signing in", error)
    return Promise.reject(error)
  }
}

export async function getToken(forceRefresh: boolean = false): Promise<string> {
  const data = await fetchAuthSession({
    forceRefresh,
  })
  return data.tokens?.idToken?.toString() || ""
}

export async function logout() {
  try {
    // No Firebase cleanup here - will be handled on next login
    return signOut()
  } catch (error) {
    window.console.log("error signing out", error)
    return Promise.reject(error)
  }
}

export async function getUser() {
  return getCurrentUser()
}

export async function getUserAttributes(forceRefresh: boolean = false) {
  if (forceRefresh) {
    await fetchAuthSession({ forceRefresh: true })
  }
  return fetchUserAttributes()
}

export function setToken(
  lastAuthUser: string,
  idToken: string,
  accessToken: string
): void {
  localStorage.setItem(
    `CognitoIdentityServiceProvider.${userPoolWebClientId}.LastAuthUser`,
    lastAuthUser
  )
  localStorage.setItem(
    `CognitoIdentityServiceProvider.${userPoolWebClientId}.${lastAuthUser}.accessToken`,
    accessToken
  )
  localStorage.setItem(
    `CognitoIdentityServiceProvider.${userPoolWebClientId}.${lastAuthUser}.idToken`,
    idToken
  )
}

export function forgotPassword(username: string) {
  try {
    return resetPassword({ username })
  } catch (error) {
    window.console.log("error sending confirmation code", error)
    return Promise.reject(error)
  }
}

export function forgotPasswordSubmit(
  username: string,
  code: string,
  new_password: string
) {
  try {
    return confirmResetPassword({
      confirmationCode: code,
      newPassword: new_password,
      username,
    })
  } catch (error) {
    window.console.log("error signing in", error)
    return Promise.reject(error)
  }
}

export async function signUp(username: string, password: string) {
  try {
    localStorage.setItem("lastSignUpUsername", username)
    localStorage.setItem("lastSignUpPassword", password)
    return amplifySignUp({
      username,
      password,
    })
    //console.log(user);
  } catch (error) {
    console.log("error signing up:", error)
  }
}

export async function confirmSignUp(username: string, code: string) {
  try {
    return amplifyConfirmSignUp({ username, confirmationCode: code })
  } catch (error) {
    console.log("error confirming sign up", error)
  }
}

export async function resendConfirmationCode(username: string) {
  try {
    return resendSignUpCode({ username })
  } catch (err) {
    console.log("error resending code: ", err)
  }
}

export default {
  login,
  getToken,
  logout,
  getUser,
  forgotPassword,
  forgotPasswordSubmit,
}
